module.exports = __webpack_public_path__ + "static/media/ruler.29c86dcf.svg";